
<template>
  <div class="sld_after_sales_list">
    <MemberTitle memberTitle="申请授信" style="padding-left: 20px"></MemberTitle>
    <div class="after_sales_list_main">
      <div class="credit_tit">
        <div class="credit_name">客户名称：{{ memberName }}</div>
        <div class="credit_name">单位名称：{{ companyName }}</div>
      </div>
      <div class="cre_con" v-if="creditFlags == 0">
        <div class="con_item submitBtn">
          <div>额度</div>
          <input type="number" v-model="creditLimit" placeholder="请输入申请的信用额度"  />
        </div>
        <div class="con_item submitBtn">
          <div>账期</div>
            <el-select placeholder="请选择账期"
          v-if="cancelList.data && cancelList.data.length > 0" @change="changeCancel($event)" v-model="creditPeriod"
          id="elSelect">
            <el-option v-for="cancelItem in cancelList.data" :key="cancelItem.FNumber" :label="cancelItem.FDescription"
                :value="cancelItem.FNumber">
            </el-option>
        </el-select>
        </div>
        <div class="cre_bom con_item submitBtn" @click="goSubmit">提交申请</div>
      </div>
      <!-- 待审核 -->
      <div class="cre_con" v-if="creditFlags">
        <div class="cre_center">
          <div class="con_item">
            <div>申请额度：</div>
            <span>{{ customDetail.data.creditLimit }}元</span>
          </div>
          <div class="con_item">
            <div>申请账期：</div>
            <span>{{ customDetail.data.creditPeriod }}天</span>
          </div>
          <div class="con_item">
            <div>提交时间：</div>
            <span>{{ customDetail.data.creditApplyTime }}</span>
          </div>
          <div class="con_item">
            <div>申请状态：</div>
            <span>{{ customDetail.data.creditStateType }}</span>
          </div>
          <div class="con_item" v-if="creditFlags == 2 || creditFlags == 3">
            <div>审核时间：</div>
            <span>{{ customDetail.data.creditAuditTime }}</span>
          </div>
          <div class="con_item" v-if="creditFlags == 3">
            <div>审核备注：</div>
            <span>{{
              customDetail.data.creditRefuseReason
              ? customDetail.data.creditRefuseReason
              : "--"
            }}</span>
          </div>
        </div>
      </div>
      <!-- 重新申请 -->
      <div class="cre_bom con_item submitBtn" @click="againSubmit" v-if="creditFlags == 3">重新申请</div>
    </div>
  </div>
</template>
<script>
import { useStore } from 'vuex'
import { onMounted, reactive, ref, getCurrentInstance, watchEffect } from "vue";
import { ElMessage, ElPagination } from "element-plus";
import SldCommonEmpty from "../../../components/SldCommonEmpty";
import { useRouter, useRoute } from "vue-router";
import MemberTitle from "../../../components/MemberTitles";

export default {
  components: {
    ElPagination,
    MemberTitle,
    SldCommonEmpty,
  },
  setup() {
    const store = useStore()
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const router = useRouter();
    const route = useRoute();
    const companyName = ref("");
    const memberName = ref("");
    const memberid = ref("");
    const creditLimit = ref("");
    const creditPeriod = ref("");
    const creditFlags = ref(-1);
    const customDetail = reactive({
      data: {},
    });
    // 审核信息
    const getCustomDetail = () => {
      let params = {
        memberId: memberid.value,
      };
      proxy.$get("v3/member/front/custom/detail", params).then((res) => {
        if (res.state == 200) {
          let result = res.data;
          creditFlags.value = 0
          customDetail.data = result;
          if (result.creditState == 1) {
            result.creditStateType = "待审核";
            creditFlags.value = 1
          }
          if (result.creditState == 2) {
            result.creditStateType = "审核通过";
            creditFlags.value = 2
          }
          if (result.creditState == 3) {
            creditFlags.value = 3
            result.creditStateType = "审核拒绝";
          }
        } else {
          creditFlags.value = 0;
          // ElMessage.error(res.msg);
        }
      });
    };

    // 失去焦点
    const blurNum = (type) => {
      if (type == "creditLimit") {
        let val = creditLimit.value;
        if (creditLimit.value) {
          setTimeout(() => {
            creditLimit.value = Number(val);
          });
          if (creditLimit.value <= 0) {
            setTimeout(() => {
              creditLimit.value = "";
            });
          }
        }
      } 
    };

    // 输入框事件
    const changnum = (type) => {
      if (type == "creditLimit") {
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        let len1 = creditLimit.value.substr(0, 1);
        let len2 = creditLimit.value.substr(1, 1);
        if (creditLimit.value.length > 1 && len1 == 0 && len2 != ".") {
          setTimeout(() => {
            creditLimit.value = creditLimit.value.substr(1, 1);
          });
        }
        //小数点保留两位
        let val = creditLimit.value.split(".");
        if (val.length == 2) {
          if (val[1].length > 1) {
            setTimeout(() => {
              creditLimit.value = Number(creditLimit.value).toFixed(2);
            });
          }
        }
      } 
    };

    // 提交
    const goSubmit = () => {
      if (!creditLimit.value) {
        ElMessage.error("请输入信用额度");
        return;
      }
      if (!creditPeriod.value) {
        ElMessage.error("请输入账期天数");
        return;
      }
      let params = {
        memberId: memberid.value,
        creditLimit: creditLimit.value,
        creditPeriod: creditPeriod.value.slice(1),
      };
      proxy.$post("v3/member/front/custom/applyCredit", params).then((res) => {
        if (res.state == 200) {
          ElMessage.success("成功");
          getCustomDetail();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };

    // 重新申请
    const againSubmit = () => {
      creditFlags.value = 0
      // router.push({ path: '/member/connection/connection' })
    }
     //选择退款原因
     const changeCancel = (e) => {
      cancelList.data && cancelList.data.map((cancelItem) => {
        if (cancelItem.FNumber == e) {
            creditPeriod.value = cancelItem.FNumber;
        }
      });

    };
    const cancelList = reactive({
      data: [],
    });
    onMounted(() => {
      // 非销售员 登录进来之后跳转首页
      if (store.state.memberInfo.isSale == 0) {
        router.push({ path: "/index" });
      }
      if (route.query.companyName) {
        companyName.value = route.query.companyName;
      }
      if (route.query.id) {
        memberid.value = route.query.id;
      }
      if (route.query.memberName) {
        memberName.value = route.query.memberName;
      }
      getCustomDetail();
      proxy.$get("v3/member/front/credit/creditPeriodList").then((res) => {
        if (res.state == 200) {
            cancelList.data = res.data
        }
      });
    });

    return {
      changeCancel,
      cancelList,
      L,
      getCustomDetail,
      companyName,
      memberid,
      memberName,
      creditLimit,
      creditPeriod,
      changnum,
      blurNum,
      goSubmit,
      creditFlags,
      customDetail,
      againSubmit,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../../style/base.scss";
@import "../../../style/iconfont.css";

.sld_after_sales_list {
  width: 1007px;
  float: left;

  .after_sales_list_main {
    background-color: #fff;
    border: 1px solid #eee;
    margin-left: 10px;
    padding: 10px 0;
    height: 1080px;

    .credit_tit {
      width: 98%;
      margin: auto;
      padding: 10px 0;
      background-color: rgba(37, 85, 170, 0.13);
      color: #2555aa;
      font-size: 14px;
      line-height: 27px;
      padding-left: 20px;
    }
  }
}

.storeName {
  color: #333;

  &:hover {
    color: $colorMain;
  }
}

.cre_con {
  margin-top: 20px;
}
.cre_center {
  width: 250px;
  margin: 0 auto;
}
.submitBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.con_item {
  display: flex;
  flex-direction: row;
  // justify-content: start;
  align-items: center;
  margin-top: 10px;
  word-wrap: break-word;

  div {
    font-size: 14px;
    font-weight: 700;
    max-width: 70px;
    // text-align: center;
  }

  span {
      width: 150px;
  }
  input {
    height: 32px;
    width: 200px;
    margin-left: 5px;
    font-size: 12px;
    padding: 0 5px;
    text-align: left;
    font-family: Microsoft Yahei;
    border: 1px solid rgba(187, 187, 187, 1);
  }
  .el-select {
    width: 200px !important;
    max-width: 200px;
    margin-left: 5px;
    font-size: 12px;
    text-align: left;
    font-family: Microsoft Yahei;
  }
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
}

.cre_bom {
  width: 100px;
  height: 30px;
  line-height: 20px;
  border-radius: 3px;
  background-color: rgba(37, 89, 132, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  margin: 20px auto;
  cursor: pointer;
}
</style>